import React, { useState } from "react";
import { MdDelete } from "react-icons/md";
import AppLayout from "../components/AppLayout";
import { v4 as uuidv4 } from "uuid";
import InputComponents from "../components/input";
import { useDispatch, useSelector } from "react-redux";
import { failedPresets, loadingPresets } from "../logic/categories/reducer";
import { addPresets } from "../logic/categories/action";
import { useNavigate, useParams } from "react-router-dom";
import Header from "../components/header";
// import { date } from 'joi';

const AddDynamicForm = () => {
  const [formsData, setformsData] = useState([
    {
      id: uuidv4(),
      name: "",
      type: "",
      nested: false,
    },
  ]);
  const [formName, setFormName] = useState("");
  const [formsDataNested, setformsDataNested] = useState({});
  const dispatch = useDispatch();
  const selector = useSelector((state) => state?.categories);
  const nav = useNavigate();
  const {id} = useParams();

  const onSubmit = () => {
    dispatch(loadingPresets());
    const json = {};
    let error = [];
    if(formsData.length<=0){
      dispatch(failedPresets({message:'please fill all details in the dynamic form'}));
      error.push(1);
      return;
    }
    formsData.forEach((ele) => {
      if(ele.name==='' || ele.type===''){
        dispatch(failedPresets({message:'Please fill all details in the dynamic form'}));
        error.push(1);
        return;
      }
      const formNestedData = formsDataNested[ele.id] || [];
      const formJson = {};
      if (ele.type === "nested") {
        if(formNestedData.length<=0){
          dispatch(failedPresets({message:'Please fill all details in the dynamic form'}));
          error.push(1);
          return;
        }
        formNestedData.forEach((elem) => {
          if(elem.name==='' || elem.type===''){
            dispatch(failedPresets({message:'Please fill all details in the dynamic form'}));
            error.push(1);
            return;
          }
          formJson[elem.name] = elem.type;
        });
      }
      if(error.length>0){
        return;
      }
      json[ele.name] = ele.type !== "nested" ? ele.type : formJson;
    });
    if(formName===''){
      dispatch(failedPresets({message:'Please fill details in the form name'}));
      return;
    }
    if(error.length>0){
      return;
    }
    console.log(JSON.stringify(json), "json form");
    addPresets(dispatch,{
      form_name:formName,
      form_fields:JSON.stringify(json),
    },nav,id);
  };
  return (
    <AppLayout>
      <div className="flex-1 h-full overflow-y-scroll p-4">
      <Header/>
      <div className="w-full h-auto flex flex-col gap-4 lg:gap-10 p-4 lg:p-10">
       
        <div>
        <h1 className="font-bold text-lg text-blue-600">Add Dynamic Form</h1>
        {
          selector.errorPresets && <p className="text-red-500">{selector.errorMessage}</p>
        }
        </div>
        <InputComponents
          label={"Form Name"}
          value={formName}
          onChange={(ev) => {
            setFormName(ev.target.value);
          }}
          name={"form_name"}
          isRequired={true}
        />
        <div className="flex justify-between items-center">
          <h2>Add Fields</h2>
          <button
                    className="text-sm !w-6 !h-8 !min-h-[1.5rem] lg:w-10 lg:h-10 lg:text-lg"
            onClick={() =>
              setformsData((prev) => [
                ...prev,
                {
                  id: uuidv4(),
                  name: "",
                  type: "",
                  nested: false,
                },
              ])
            }
          >
            +
          </button>
        </div>
        <div className="shadow-2xl rounded-lg flex flex-col gap-4 lg:gap-10 p-4 lg:p-10">
          {formsData?.map((e, i) => (
            <div
              className="flex flex-col items-start gap-4 p-4 relative"
              key={i}
            >
              <div className="w-full flex items-start gap-4">
                <button
                  onClick={() => {
                    console.log("hi");
                    setformsData((prev) => prev.filter((el) => el.id !== e.id));
                  }}
                  className="absolute text-white !w-6 !h-8 !min-h-[1.5rem] lg:w-10 lg:h-10 flex items-center justify-center text-center rounded-full lg:top-0 lg:-right-0 top-0 right-0"
                >
                  -
                  {/* <MdDelete color="white" className="w-4 h-4"/> */}
                </button>
                <InputComponents
                  label={"Name"}
                  name={"name_uppper"}
                  type="text"
                  placeholder="Name"
                  value={e?.name}
                  onChange={(ev) => {
                    let newArr = [...formsData];
                    newArr[i] = { ...newArr[i], name: ev.target.value };
                    setformsData(newArr);
                  }}
                />
                <select
                  onChange={(ev) => {
                    let newArr = [...formsData];
                    newArr[i] = { ...newArr[i], type: ev.target.value };
                    setformsData(newArr);
                    setformsDataNested((prev) => ({
                      ...prev,
                      [e.id]: [
                        {
                          uuid: uuidv4(),
                          name: "",
                          type: "",
                        },
                      ],
                    }));
                  }}
                  className="h-10 outline-none rounded-md px-4 w-full"
                  name="Type"
                  id=""
                  value={e.type}
                >
                  <option value="" disabled>
                    Select Type
                  </option>
                  <option value="text">Text</option>
                  <option value="number">Number</option>
                  <option value="nested">Nested</option>
                </select>
              </div>
              {e.type === "nested" ? (
                <>
                  <div className="w-full items-center flex justify-between">
                    <h4>Nested</h4>
                    <button
                    className="text-sm !w-6 !h-8 !min-h-[1.5rem] lg:w-10 lg:h-10 lg:text-lg"
                      onClick={() => {
                        if (
                          formsDataNested[e.id] === undefined ||
                          formsDataNested[e.id] == null
                        ) {
                          console.log("here in if", formsDataNested[e.id]);
                          setformsDataNested((prev) => ({
                            ...prev,
                            [e.id]: [
                              {
                                uuid: uuidv4(),
                                name: "",
                                type: "",
                              },
                            ],
                          }));
                        } else {
                          console.log("here", formsDataNested[e.id]);
                          setformsDataNested((prev) => ({
                            ...prev,
                            [e.id]: [
                              ...formsDataNested[e.id],
                              {
                                uuid: uuidv4(),
                                name: "",
                                type: "",
                              },
                            ],
                          }));
                        }
                      }}
                    >
                      +
                    </button>
                  </div>
                  <div className="flex flex-col gap-4">
                    {formsDataNested[e.id]?.map((el, index) => (
                      <div
                        className="w-full items-center flex gap-4"
                        key={index}
                      >
                        <InputComponents
                          label={"Name"}
                          name="name"
                          isRequired={true}
                          onChange={(ev) => {
                            let newArr = [...formsDataNested[e.id]];
                            newArr[index] = {
                              ...newArr[index],
                              name: ev.target.value,
                            };
                            setformsDataNested((prev) => ({
                              ...prev,
                              [e.id]: newArr,
                            }));
                          }}
                          value={formsDataNested[e.id][index].name}
                          type="text"
                          placeholder="name"
                        />
                        <select
                          onChange={(ev) => {
                            let newArr = [...formsDataNested[e.id]];
                            newArr[index] = {
                              ...newArr[index],
                              type: ev.target.value,
                            };
                            setformsDataNested((prev) => ({
                              ...prev,
                              [e.id]: newArr,
                            }));
                          }}
                          value={formsDataNested[e.id][index].type}
                          className="h-10 outline-none rounded-md px-4 w-full"
                          name="Type"
                          id="Type"
                        >
                          <option value="" disabled>
                            Select Type
                          </option>
                          <option value="text">Text</option>
                          <option value="number">Number</option>
                        </select>
                        <button
                          onClick={() => {
                            setformsDataNested((prev) => ({
                              ...prev,
                              [e.id]: formsDataNested[e.id].filter(
                                (ele) => ele.uuid !== el.uuid
                              ),
                            }));
                          }}
                          className="items-center justify-center flex !w-8 !h-8 !min-h-[1.5rem] lg:w-10 lg:h-10"
                        >
                          -
                          {/* <MdDelete color="white" className="w-4 h-4 lg:w-6 lg:h-6"/> */}
                        </button>
                      </div>
                    ))}
                  </div>
                </>
              ) : (
                ""
              )}
            </div>
          ))}
        </div>
        <div className="w-full">
        {
          selector.errorPresets && <p className="text-red-500 w-full text-center pb-2">{selector.errorMessage}</p>
        }
        <button disabled={selector.loadingPresets} onClick={onSubmit} type="button" className="w-full">
          SUBMIT
        </button>
        </div>
        <div className="h-10 w-full">
        </div>
      </div>
      </div> 
    </AppLayout>
  );
};

export default AddDynamicForm;
